/* eslint-disable complexity */
import {
    Divider, Tab, TabList, TabPanels, Tabs,
} from '@chakra-ui/react';
import { Hide, Show, TabDropdown } from '@acp/core-ui';
import { OverdueInvoicesTab } from './overdue-invoices-tab/overdue-invoices-tab';
import { UrgentActiveNoticesTab } from './urgent-active-notices-tab/urgent-active-notices-tab';
import { useActionRequiredTab } from '../hooks/use-action-required-tab';
import { CardLayout } from './card-layout';
import { NewManagementsTab } from './new-managements-tab/new-managements-tab';
import { UrgentAccessIssuesTab } from './urgent-access-issues-tab/urgent-access-issues-tab';
import { UrgentReportedFindingsTab } from './urgent-reported-findings-tab/urgent-reported-findings-tab';
import { useActionRequiredCard } from '../hooks/use-action-required-card';

export function ActionRequiredCard(
    { propertyManagerId }: { propertyManagerId?: string }
) {
    const {
        selectedTabIndex,
        setTabByIndex,
    } = useActionRequiredTab();
    const {
        isIntegrated,
        isAccessIssuesEnabled,
        propertyManager,
        urgentReportedFindingsTabText,
        newManagementTabText,
        accessIssuesTabText,
        overdueInvoicesTabText,
        tabDropdownItems,
    } = useActionRequiredCard(propertyManagerId);

    return (
        <CardLayout bgColor="white" gap={3} id="action-required">

            <CardLayout.Title width="100%" flexDir={['column', null, 'row']} alignItems={['stretch', null, 'center']} h={[null, null, 10]}>
                <CardLayout.Title.Heading
                    heading={`Urgent action required ${propertyManager !== null ? `for ${propertyManager.name}` : ''}`}
                    pb={[2, null, 0]}
                    flexGrow={1}
                />
            </CardLayout.Title>
            <CardLayout.Body>
                <Tabs
                    isLazy
                    index={selectedTabIndex}
                    w="100%"
                    variant="underline"
                    colorScheme="primary"
                    fontSize="md"
                    onChange={(idx) => setTabByIndex(idx)}
                >
                    <Show above="md">
                        <TabList w="100%" gap={[0, null, 6]}>
                            {
                                isIntegrated && (
                                    <Tab>
                                        {newManagementTabText}
                                    </Tab>
                                )
                            }
                            <Tab>{urgentReportedFindingsTabText}</Tab>
                            <Tab>{accessIssuesTabText}</Tab>
                            <Tab>{overdueInvoicesTabText}</Tab>
                        </TabList>
                        <Divider borderColor="muted.100" />
                    </Show>

                    <Hide above="md">
                        <TabDropdown
                            items={tabDropdownItems}
                            w="full"
                            fontWeight="medium"
                            fontSize="sm"
                        />
                    </Hide>

                    <TabPanels pt={6}>
                        { isIntegrated && (<NewManagementsTab />) }
                        <UrgentReportedFindingsTab propertyManagerId={propertyManagerId} />
                        {isAccessIssuesEnabled
                            ? <UrgentAccessIssuesTab propertyManagerId={propertyManagerId} />
                            : <UrgentActiveNoticesTab propertyManagerId={propertyManagerId} /> }
                        <OverdueInvoicesTab propertyManagerId={propertyManagerId} />
                    </TabPanels>
                </Tabs>
            </CardLayout.Body>
        </CardLayout>
    );
}
